import { API_URL } from '../config/connect';

/**
 * Converts a flat JavaScript object (with dot notation for nested fields) 
 * into a FormData instance. This is required because the backend accepts 
 * form-data, not raw JSON, and expects primitive fields.
 * * NOTE: This utility assumes the input object `updatedData` is already 
 * prepared by the modal component (AdDetailsModalContent) and contains 
 * all necessary data (including the 'image_updates' string, if applicable).
 * * @param {Object} data - The data object to process (contains primitives and JSON strings).
 * @returns {FormData} The populated FormData object.
 */
const prepareFormData = (data) => {
    const formData = new FormData();

    Object.keys(data).forEach(key => {
        const value = data[key];

        // Special handling for images: support FileList or Array<File>
        if (key === 'images') {
            if (value && typeof value === 'object') {
                const filesArray = Array.from(value);
                filesArray.forEach((file) => {
                    if (file) {
                        formData.append('images', file);
                    }
                });
            }
            return; // handled
        }

        // keywords: array of strings → JSON string in form-data
        if (key === 'keywords') {
            if (Array.isArray(value) && value.length > 0) {
                formData.append(key, JSON.stringify(value));
            }
            return; // handled
        }

        // Ensure booleans are strings; null/undefined as empty string
        let finalValue;
        if (typeof value === 'boolean') {
            finalValue = value ? 'true' : 'false';
        } else if (value === null || value === undefined) {
            finalValue = '';
        } else {
            finalValue = value;
        }

        formData.append(key, finalValue);
    });

    return formData;
};


// Function accepts the announcement ID and the data object to send in the request body
const editAnnoucmentByID = async (id, updatedData) => {
    const googleIdToken = localStorage.getItem("google_id_token");
    
    // 1. Prepare FormData object
    const formData = prepareFormData(updatedData);
    
    // console.log("FormData contents being sent:");
    // for (const pair of formData.entries()) {
    //     console.log(pair[0] + ': ' + pair[1]);
    // }

    try {
        const response = await fetch(`${API_URL}/api/v1/admin/announcement/${id}`, {
            method: 'PATCH',
            headers: {
                'Accept': 'application/json',
                // DO NOT set 'Content-Type': 'multipart/form-data'. 
                Authorization: `Bearer ${googleIdToken}`,
            },
            body: formData, // Use FormData as the body
        });

        if (!response.ok) {
            const errorBody = await response.json().catch(() => ({ message: response.statusText }));

            console.error("Server validation or error details:", errorBody);

            const errorMessage = errorBody.detail?.[0]?.msg || errorBody.message || JSON.stringify(errorBody);
            throw new Error(`Error ${response.status}: ${errorMessage}`);
        }

        const data = await response.json();
        return data;
    } catch (error) {
        console.error('Error updating announcement:', error);
        throw error;
    }
};

export default editAnnoucmentByID;
